import api from "@/apis/maintenance-api.js";
// 访问次数统计并更新uuid
export const setStatistics = async function () {
  const user = window.localStorage.getItem("OILUSER");
  const params = {
    uuid: user,
    scheme_id: this.$route.query.scheme_id || this.$route.query.id,
  };
  try {
    const res = await api.visitRecord(params);
    if (res.code == 0) {
      window.localStorage.setItem("OILUSER", res.data.uuid);
      console.log("数据统计成功");
    } else {
      console.error("数据统计失败", res.message);
    }
  } catch (error) {
    error && console.error("数据统计失败", error);
  }
};
